import { c as _c } from "react/compiler-runtime";
import { useEmailComposer } from "../../context";
import { storedAttributeProps } from "../html-attributes";
import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";
import { getParagraphStyles } from "./styles";
interface Props {
  attrs: Record<string, unknown>;
  updateAttrs: (attrs: Record<string, unknown>) => void;
  selected: boolean;
}
export function ParagraphTiptapView(t0) {
  const $ = _c(11);
  const {
    attrs,
    selected
  } = t0;
  const {
    styleSettings
  } = useEmailComposer();
  const t1 = selected || undefined;
  let t2;
  if ($[0] !== attrs) {
    t2 = storedAttributeProps(attrs);
    $[0] = attrs;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== attrs || $[3] !== styleSettings) {
    t3 = getParagraphStyles(attrs, styleSettings);
    $[2] = attrs;
    $[3] = styleSettings;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <NodeViewContent {...t2} style={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4) {
    t5 = <NodeViewWrapper data-block-type="emailParagraph" data-selected={t1}>{t4}</NodeViewWrapper>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}